import { useQuery } from '@tanstack/react-query';
import { getCancellationWaitlistEntry } from '../../services/cancellation-waitlist';

/** Full detail for one entry (detail sidebar / notify dialog). */
function useWaitlistEntry(waitlistEntryId: string | null) {
  return useQuery({
    queryKey: ['cancellation-waitlist-entry', waitlistEntryId],
    queryFn: () => getCancellationWaitlistEntry(waitlistEntryId!),
    enabled: !!waitlistEntryId,
  });
}

export default useWaitlistEntry;
